<template>
<div>
<el-row>
<el-col :span="2"><div class="grid-content"></div></el-col>
<el-col :span="20">
<div class="title">
<h1> 产品创意设计工具（网络应用程序）</h1>
</div>
<div class="video">
<div class="">
<video controls="" muted="" src="../assets/CC.mp4">
                        我的天啊！我的视频在哪里？
                        </video>
</div>
</div>
<div class="abstract">
                    在服务机器人概念设计过程中，引入了“价值联动”理论，一种以用户为中心的概念设计。
                    构建了设计框架，提出了定性与定量相结合的设计决策方法，以帮助
                    设计师有效地开发出具有特定文化特征的服务机器人产品概念。在此基础上，建立了一个基于网络的
                    开发设计工具，邀请设计者使用该工具进行设计实践，验证设计框架的有效性
                    和决策方法。结果表明，该方法能够有效支持设计师在概念设计上的创意输出。
                    设计阶段，具有良好的知识承载和创意激发能力，但设计工具的易用性仍有待提高
                    改善了。未来，该方法和工具可以扩展到更多设计对象和文化的设计领域。
                    属性已整合。
                </div>
</el-col>
<el-col :span="2"><div class="grid-content"></div></el-col>
</el-row>
<el-row :gutter="40" style="margin-top: 50px">
<el-col :span="2"><div class="grid-content"></div></el-col>
<el-col :span="8">
<div class="picture">
<img src="../assets/project7_1.png.webp"/>
</div>
</el-col>
<el-col :span="12">
<div class="sub-title">
                    “价值联动”理论视角下的概念设计框架
                </div>
<div class="text">
                    马克斯·韦伯的“价值关联”理论认为，这个世界对于每个个体的价值取决于对世界的价值态度。如果一个人不向世界表达自己，那么生活的世界无论多么丰富多彩，对他来说都是毫无价值的。 20世纪80年代中期以来，文化心理学继承了“价值关联”理论，开始强调文化不是人类心理行为的外在决定因素，而是人类意识、理解和行动的内在存在。换句话说，文化心理学将人类思维视为内容驱动的、特定领域的、环境结构化的、历史变化的和文化多样性的。其中，施威德的文化心理学理论。 RA具有一定的代表性。他指出，“文化”指的是意向世界，意向世界存在的前提是有意者从中夺取意义或资源，而不能独立存在。 施威德提出的意向世界与意向人相互依存的文化心理学概念。 RA可以看作是文化心理学中“价值关联”理论的具体体现，该理论研究人们从意向世界中提取意义或资源时生产产品的过程。意向世界是一个重要的研究内容。从“价值关联”的角度来看，文化资源和服务机器人产品都是有意识的个体从一定的有意识世界中抓取意义和资源的结果。在概念设计中，意向性是指预期的用户（或目标用户），捕捉意义和资源的过程就是产生意图的过程，捕捉到的意义和资源就是用户动机。从价值关联的角度来看，“有心的个体”是一切的核心和关键，这也符合以用户为中心的设计原则。
                </div>
</el-col>
<el-col :span="2"><div class="grid-content"></div></el-col>
</el-row>
<el-row :gutter="40" style="margin-top: 50px">
<el-col :span="2"><div class="grid-content"></div></el-col>
<el-col :span="12">
<div class="sub-title">
                    管理信息系统框架
                </div>
<div class="text">
                    因此，设计具有鲜明文化属性的服务机器人是连接和融合两个意向世界，成为一个新的、一体化的意向世界的有效途径。整合两个意向世界需要考虑以下问题：

                    <br/><br/>（1）是否存在共同的用户动机（在本研究中用字母M表示，取自动机）；

                    <br/><br/>（2）用户对意向世界是否有一定程度的意向（在本研究中用字母I表示，取自意图）；

                    <br/><br/> （3）用户意图生成过程中是否存在相似性（本研究中用字母S表示，S取自相似）

                    <br/><br/>该概念设计框架强调产品概念受M、I、S共同影响，因此在本研究中被称为管理信息系统框架。
                </div>
</el-col>
<el-col :span="8">
<div class="picture">
<img src="../assets/project7_2.png.webp"/>
</div>
</el-col>
<el-col :span="2"><div class="grid-content"></div></el-col>
</el-row>
<el-row :gutter="40" style="margin-top: 50px">
<el-col :span="2"><div class="grid-content"></div></el-col>
<el-col :span="8">
<div class="picture">
<img src="../assets/project7_3.png.webp"/>
<img src="../assets/project7_4.png.webp"/>
<img src="../assets/project7_5.png.webp"/>
</div>
</el-col>
<el-col :span="12">
<div class="sub-title">
                    基于模糊层次分析法的概念设计决策方法
                </div>
<div class="text">
                    根据模糊层次分析法的流程，产品概念设计过程的决策过程首先分解为三个层次：目标层、准则层和衡量层（如图3所示）。产品定义 (A) 的重要性分析作为此分析的目标层。基于管理信息系统概念设计框架的定义，准则层作为评估最终产品定义重要性的三个维度：用户动机（M）、意图程度（I）和意图生成过程的相似度（S）。产品定义（D）是最终的分析目标，作为衡量层。如果产品定义中的具体项目，如外观样式、材质、用途等用字母P表示，则D={P 1、P2、P3...Pi}。

                   <br/><br/> 在管理信息系统框架下，本研究引入模糊层次分析法（模糊一致性判断矩阵）来解决最终产品定义的决策问题。模糊层次分析法作为定量和定性方法的结合，能够以数学和物理的方式规范设计过程中的主观要素。通过计算不同产品定义项P在M、I、S维度上的得分，可以得到产品定义D的权重向量{W_{错误}^T，从而确定每个产品定义项P_i的重要性，为设计者最终的设计过程提供有效指导。

                    本研究使用Java矩阵运算包（美国医学会杂志）来执行与模糊层次分析法相关的矩阵运算。 美国医学会杂志可以更轻松地与网络项目集成，为未来设计工具的开发奠定基础。

                    <br/><br/>本研究邀请了12位设计师（均具有两年以上设计专业学习经验）进行研讨会，旨在了解M、I、S维度的权重。实验过程中，研究人员首先向设计者介绍了三维概念以及管理信息系统概念设计框架指导下的设计流程。设计人员被要求在 14 天内使用该框架进行服务机器人概念设计。设计完成后，要求设计师从三个维度对设计理念的影响力进行排名。根据排序结果，得出S&gt;I&gt;M的结论，因此，本研究建立了产品定义重要性分析（A）的模糊一致性判断矩阵（一级模糊一致性判断矩阵），如式（1）所示。
                    <br/><br/>值1表示两个因素的重要性一致，2表示该因素的重要性略高于另一个因素，3表示该因素的重要性显着高于另一个因素。

                    本研究使用贾玛中的伊格（）函数计算矩阵的特征值和特征向量（计算过程与3.2中描述的类似）。计算出最大特征值，拉姆达_{最大限度}=3.0055，对应的特征向量为左边[开始{矩阵}0.26\\0.47 0.85结尾{矩阵}正确的]，最终权重为{W_a}^T=左边[开始]{矩阵}0.16&amp;0.30&amp;0.54结尾{矩阵}正确的]。

                    一致性检验公式如式(2)所示，其中n为式(1)的矩阵阶数，即n=3。经计算，模糊一致性判断矩阵满足一致性要求（CI=0.0028小于0.1），说明得到的权重{W_a}^T有效。
                </div>
</el-col>
<el-col :span="2"><div class="grid-content"></div></el-col>
</el-row>
<el-row :gutter="40" style="margin-top: 50px">
<el-col :span="2"><div class="grid-content"></div></el-col>
<el-col :span="12">
<div class="sub-title">
                    测量层重计算：管理信息系统值
                </div>
<div class="text">
                    首先，建立产品定义重要性的模糊一致性判断矩阵。本研究使用 {PM}_i 、 {PI}_i 和 {PS}_i 表示每个产品定义在 M、I、S 维度上的得分。 i 表示产品定义的数量。 M的模糊一致性判断矩阵如式(3)所示，I与S、M相同。
                    <br/><br/>为了简化计算，更注重验证方法的可行性，结合李克特五点量表的原理，本研究将所有需要设计者分配的数字分为五个级别，取值分别为1、3、5、7、9
                    <br/><br/>{PM}_i 该产品定义的用户动机级别（由用户研究确定） {PM}_i ={1,3,5,7,9}

                    <br/><br/>{PI}_i 该产品定义的意图级别（由用户研究确定） {PI}_i ={1,3,5,7,9}

                    <br/><br/> {PS}_i 生成产品定义所依据的相似产品需求项和文化资源特征项的数量（由设计者确定）（n代表实际相似项的数量），{PS}_i =1（n=0,1,2,3），{PS}_i =3（n=4,5,6），{PS}_i =5（n=7,8,9），{PS}_i =7（n=10,11,12）， {PS}_i =9 (n=13,14,15)

                    <br/><br/>   通过计算，得到产品定义(D)的权重向量({W_{错误}}^T)。产品定义的具体项(P_i)的权重依次对应于{W_{错误}}^T矩阵中的每个元素。元素值越大，产品定义的重要性越高。本研究将测度层最终计算得到的{W_{错误}}^T的每个元素命名为P_i的‘管理信息系统值’。

                </div>
</el-col>
<el-col :span="8">
<div class="picture">
<img src="../assets/project7_6.png.webp"/>
<img src="../assets/project7_7.png.webp"/>
<img src="../assets/project7_8.png.webp"/>
</div>
</el-col>
<el-col :span="2"><div class="grid-content"></div></el-col>
</el-row>
</div>
</template>

<script>
    export default {
        name: "Project7Zh"
    }
</script>

<style scoped>
    .picture img{
        width: 100%;
    }
    .sub-title{
        margin-bottom: 20px;
        font-size: 15px;
        color: #666;
        font-weight: 400;
        text-align: justify;
    }
    .text{
        font-size: 15px;
        color: #333;
        font-weight: 100;
        text-align: justify;
    }
    .abstract{
        margin-top: 40px;
        font-size: 15px;
        color: #333;
        font-weight: 100;
        text-align: justify;
    }
    video{
        width: 100%;
    }
    .grid-content{
        min-height: 36px;
    }
    .video{
        margin-top: 100px;
    }
    .title{
        margin-top: 100px;
        text-align: center;

    }
    .title a{
        color: #333;
    }
    .title p{
        color: #aaa;
        line-height: 30px;
    }
    .title h1{
        font-size:30px;
        font-weight: 100;
        letter-spacing:6px;
        color: #333333;
    }
</style>